import { LineSkeleton } from 'components/base/Skeletons';
import styled from 'styled-components';
import { StyledInsightItem } from './InsightItem/InsightItem.style';

const StyledLoader = styled.div`
  margin-top: 1rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const StyledLoaderLine = styled(StyledInsightItem)`
  border-bottom: none;
`;

const Loader = () => {
  const totalLines = 7;
  return (
    <StyledLoader>
      {[...Array(totalLines)].map((_, idx) => (
        <StyledLoaderLine key={idx}>
          <LineSkeleton size={100} />
        </StyledLoaderLine>
      ))}
    </StyledLoader>
  );
};

export default Loader;
